import React from 'react';
import styled from 'styled-components';

import ImgGoods from './images/banner.jpg';
import titleImg from './images/title/Goods.png';
import Section from './section';

/**
 * Number of warnings to display
 * Must correspond with locale file
 */

const Image = styled.img`
  margin-top: 3em;
  width: 100%;
`;

const Atag = styled.a`
  display: block;
`;

/**
 * Goods section
 */
const Goods = () => (
  <Section imgSrc={titleImg}>
    <Atag href="https://mall.nhn-playart.com/">
      <Image src={ImgGoods} />
    </Atag>
  </Section>
);

export default Goods;
